import { render, staticRenderFns } from "./ReviewHeaderContent.vue?vue&type=template&id=3efeb5d4&scoped=true"
import script from "./ReviewHeaderContent.vue?vue&type=script&lang=js"
export * from "./ReviewHeaderContent.vue?vue&type=script&lang=js"
import style0 from "./ReviewHeaderContent.vue?vue&type=style&index=0&id=3efeb5d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efeb5d4",
  null
  
)

export default component.exports